import React, { useState, useEffect } from "react";
import { Box, Button, Dialog, DialogTitle, DialogContent, Typography, Checkbox, IconButton, TextField, } from "@mui/material";
import { FiUpload } from "react-icons/fi";
import { LuTrash2 } from "react-icons/lu";
import { useParams } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import { useTriggerWorkflowMutation } from "store/slices/apis/workFlowSlice";

const TriggerWorkflow = (props) => {
    const dispatch = useDispatch();
    const { projectId } = useParams();
    const { open, handleClose, title, rowData } = props;
    const [files, setFiles] = useState([]);

    const validationSchema = Yup.object().shape({
        scheduleDetail: Yup.string()
            .trim()
            .required("Please enter the description."),
        // files: Yup.array().min(1, "Please upload a file."),
    });
    const [triggerWorkflowFn, triggerWorkflowRes] = useTriggerWorkflowMutation();

    const handleFileUpload = (event, setFieldValue) => {
        const uploadedFile = event.target.files[0];
        if (uploadedFile) {
            setFiles([uploadedFile]);
            setFieldValue("files", [uploadedFile]);
        }
    };

    const handleRemoveFile = (setFieldValue) => {
        setFiles([]);
        setFieldValue("files", []);
    };


    React.useEffect(() => {
        if (triggerWorkflowRes?.isSuccess) {
            if (triggerWorkflowRes?.data?.status?.toLowerCase() == 'success') {
                openNotification(triggerWorkflowRes?.data?.message, 'success')
                setFiles([]);
                handleClose();
            } else {
                openNotification(triggerWorkflowRes?.data?.message, 'error')
            }
        }
    }, [triggerWorkflowRes?.isSuccess]);


    React.useEffect(() => {
        if (triggerWorkflowRes?.isError) {
            if (triggerWorkflowRes?.error?.data?.status?.toLowerCase() == 'error') {
                openNotification(triggerWorkflowRes?.error?.data?.message ?? 'Something went wrong!', 'error')
            } else if (triggerWorkflowRes?.error?.data?.status?.toLowerCase() == 'fail') {
                openNotification(triggerWorkflowRes?.error?.data?.message ?? 'Something went wrong!', 'error')
            } else {
                openNotification(triggerWorkflowRes?.error?.data?.message ?? 'Something went wrong!', 'error')
            }
            handleClose();
        }
    }, [triggerWorkflowRes?.isError]);

    // const handleSubmit = (values) => {
    //     console.log("Form submitted:", values);
    //     openNotification("File uploaded successfully!", 'success')
    //     handleClose();
    // };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {

        const formData = new FormData();
        formData.append('entityType', rowData?.entityName);
        formData.append('description', values?.scheduleDetail);
        formData.append('files', values?.files[0]);
        formData.append('data', null);

        triggerWorkflowFn({
            projectId: projectId,
            body: formData
        })

        // try {
        //     await startScheduleWorkflow({
        //         scheduleDetail: values.scheduleDetail,
        //         files: values.files,
        //         projectId: projectId,
        //         type: title
        //     }).unwrap();

        //     openNotification("Workflow triggered successfully!", "success");
        //     resetForm();
        //     setFiles([]);
        //     handleClose();
        // } catch (err) {
        //     console.error(err);
        //     openNotification(
        //         err?.data?.message ||
        //         err?.error ||
        //         "Something went wrong while triggering workflow.",
        //         "error"
        //     );
        // } finally {
        //     setSubmitting(false);
        // }
    };

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    return (
        <>
            {/* ---------- Popup Dialog ---------- */}
            <Dialog
                open={open}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
                }}
                disableEscapeKeyDown
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        borderBottom: "1px solid #ddd",
                        backgroundColor: "#ECECEC",
                        pb: 2,
                        pt: 3,
                        width: "100%",
                    }}
                >
                    <Box>
                        <Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                            {"Initiate Workflow"}
                        </Typography>
                        <Typography sx={{
                            pt: 2, fontWeight: 400, fontSize: "14px", lineHeight: "100%", color: "#433F5E", fontFamily: "Outfit, sans-serif",
                        }}>
                            This will trigger the {title} workflow
                        </Typography>
                    </Box>

                </DialogTitle>
                <Formik
                    initialValues={{ scheduleDetail: "", files: [], }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ values, errors, handleChange, handleBlur, touched, setFieldValue, isSubmitting }) => (
                        <Form encType="multipart/form-data">
                            <DialogContent sx={{ width: "100%", p: 4, overflowX: "hidden", boxSizing: "border-box" }}>
                                <TextField
                                    fullWidth
                                    name="scheduleDetail"
                                    value={values.scheduleDetail}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    multiline
                                    rows={3}
                                    placeholder="Enter the detailed description of the task to be performed."
                                    InputProps={{
                                        sx: {
                                            // height: "50px",
                                            borderRadius: "8px",
                                            backgroundColor: "#fff",

                                            "& input::placeholder": {
                                                fontWeight: 400,
                                                fontSize: "16px",
                                                lineHeight: "100%",
                                                letterSpacing: "0.16px",
                                                color: "#0A0A0C",
                                                fontFamily: "Outfit, sans-serif",
                                                opacity: 1,
                                            },

                                            "& input": {
                                                fontWeight: 400,
                                                fontSize: "16px",
                                                lineHeight: "100%",
                                                letterSpacing: "0.16px",
                                                color: "#0A0A0C",
                                                fontFamily: "Outfit, sans-serif",
                                            },
                                        },
                                    }}
                                />
                                {touched.scheduleDetail && errors.scheduleDetail && (
                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                        {errors.scheduleDetail}
                                    </Typography>
                                )}

                                {files.length === 0 && (
                                    <Box
                                        sx={{
                                            mt: 3,
                                            position: "relative",
                                            borderRadius: "3px",
                                            backgroundColor: "#ECECEC",
                                            height: 120,
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            transition: "all 0.2s ease",
                                            backgroundImage: `
                                repeating-linear-gradient(90deg, rgba(113,131,155,0.7) 0 5px, transparent 5px 10px),   /* top */
                                repeating-linear-gradient(180deg, rgba(113,131,155,0.7) 0 5px, transparent 5px 10px), /* right */
                                repeating-linear-gradient(90deg, rgba(113,131,155,0.7) 0 5px, transparent 5px 10px),  /* bottom */
                                repeating-linear-gradient(180deg, rgba(113,131,155,0.7) 0 5px, transparent 5px 10px)  /* left */
                            `,
                                            backgroundRepeat: "no-repeat",
                                            backgroundSize: "100% 1px, 1px 100%, 100% 1px, 1px 100%",
                                            backgroundPosition: "top left, top right, bottom left, top left",
                                        }}
                                        onClick={() => document.getElementById("fileUploadInput").click()}
                                    >
                                        <input
                                            type="file"
                                            id="fileUploadInput"
                                            hidden
                                            multiple
                                            onChange={(e) => handleFileUpload(e, setFieldValue)}
                                        />

                                        <FiUpload color="#71839B" size={42} />
                                        <Typography
                                            sx={{
                                                mt: 1,
                                                fontSize: "14px",
                                                fontWeight: 400,
                                                lineHeight: "100%",
                                                letterSpacing: "0.14px",
                                                color: "#71839B",
                                                fontFamily: "Outfit, sans-serif",
                                            }}
                                        >
                                            Upload attachment
                                        </Typography>
                                    </Box>
                                )}

                                {files.length > 0 && (
                                    <Box

                                        sx={{
                                            display: "flex", alignItems: "center", gap: 1, mt: 2,
                                            border: "1px solid #ECECEC",
                                            borderRadius: 1,
                                            px: 2,
                                            py: 4,
                                        }}>
                                        <Typography
                                            sx={{
                                                fontWeight: 400,
                                                fontSize: "14px",
                                                color: "#324054",
                                                lineHeight: "22px",
                                                fontFamily: "Outfit, sans-serif",
                                            }}
                                        >
                                            File: {files[0].name}
                                        </Typography>

                                        <IconButton
                                            onClick={() => handleRemoveFile(setFieldValue)}
                                        >
                                            <LuTrash2 color="red" size={15} />
                                        </IconButton>

                                    </Box>
                                )}
                                {touched.files && errors.files && (
                                    <Typography
                                        sx={{
                                            mt: 1,
                                            color: "#F15744",
                                            fontSize: "13px",
                                            fontFamily: "Outfit, sans-serif",
                                        }}
                                    >
                                        {errors.files}
                                    </Typography>
                                )}

                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: { xs: "column", md: "row" },
                                        gap: { xs: 2, md: 1 },
                                        width: "100%",
                                        boxSizing: "border-box",
                                        overflowX: "hidden",
                                        justifyContent: 'flex-end',
                                        mt: 4,
                                    }}
                                >
                                    <Button onClick={handleClose}
                                        sx={{
                                            textTransform: "none",
                                            color: "#F15744",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            lineHeight: "100%",
                                            fontFamily: "Outfit, sans-serif",
                                        }}>
                                        Cancel
                                    </Button>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        disabled={triggerWorkflowRes?.isLoading}
                                        sx={{
                                            backgroundColor: "#00344C",
                                            borderRadius: "25px",
                                            textTransform: "none",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            lineHeight: "100%",
                                            fontFamily: "Outfit, sans-serif",
                                            color: "#FFFFFF",
                                            px: "18px",
                                            py: "12px",
                                        }}
                                    >
                                        {triggerWorkflowRes?.isLoading ? "Submitting..." : "Submit"}
                                    </Button>
                                </Box>
                            </DialogContent>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </>
    );
};

export default TriggerWorkflow;